/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* MonthlyFrequencyConfig holds settings that apply when frequency = MONTHLY.
*/
export class V1MonthlyFrequencyConfig {
    /**
    * One or more days of the month, integers in 1..31 inclusive. Required (non-empty).
    */
    'daysOfMonth': Array<number>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "daysOfMonth",
            "baseName": "days_of_month",
            "type": "Array<number>",
            "format": "int32"
        }    ];

    static getAttributeTypeMap() {
        return V1MonthlyFrequencyConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

